import { Box, Flex, Heading, useMediaQuery } from '@chakra-ui/react';
import Item from 'antd/lib/list/Item';
import { title } from 'process';
import React from 'react';
import { responsiveValue } from '../../../assets/style/defaultTheme';
import { theme } from '../../../assets/style/theme';
import { lineBreakToBr } from '../../../util';

type Props = {
  data: any;
};

function ParticipationContentItemDefine({ data }: Props) {

  const { flexBoxDirection } = responsiveValue;
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <>
    {
    data.map((item:any, index:number) => (
      <Flex key={index} justify="space-between" pt="3" pb="3" direction={flexBoxDirection}>
        <Heading size="2xl" color="b.bk"  dangerouslySetInnerHTML={ {__html: item.title } } pb={isMobile ? '4' : '0'} maxW={isMobile ? '100%' : '20%'} wordBreak="break-word" />
        <Box color="b.g" w={isMobile ? '100%' : '74%'} lineHeight="1.6" dangerouslySetInnerHTML={ {__html: item.text } }>
        </Box>
      </Flex>
    ))
  }
    </>
    
  );
}

ParticipationContentItemDefine.defaultProps = {
};

export default ParticipationContentItemDefine;
